<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <div class="home">
    <!-- <div class="bt_footer_mobile">
      <a type="button" href="#receba" class="w-100 btn  btn-success">EU QUERO</a>
    </div> -->
    <div class="container-fluid padding-zero" style="min-height: 100vh;">
      <div class="container-fluid padding-zero bg_pepio2" style="min-height: 100vh;">
        <div class="container-fluid ">
          <div class="container padding_categoria">
            <router-view />

            <Footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Footer from '@/components/Footer.vue'
</script>